// import React, { useEffect, useState } from "react";
// import { X, Star, Upload } from "lucide-react";
// import { toast } from "react-hot-toast";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { createPortal } from "react-dom";

// const ReviewModal = ({ open, onClose, productId, existingReview  }) => {
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [feedback, setFeedback] = useState("");
//   const [image, setImage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [existingImage, setExistingImage] = useState(null);


//   //  ALWAYS RUNS
//   useEffect(() => {
//     if (existingReview && open) {
//       setRating(existingReview.rating);
//       setFeedback(existingReview.comment);
//       setExistingImage(existingReview.images?.[0] || null);
//       setImage(null); // reset new upload
//     }

//     if (!existingReview && open) {
//       setRating(0);
//       setFeedback("");
//       setImage(null);
//       setExistingImage(null);
//     }
//   }, [existingReview, open]);

//   //  return AFTER hooks
//   if (!open) return null;

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) setImage(file); // store FILE, not URL
//   };

//   const handleRemoveImage = () => {
//   setImage(null);          // remove newly selected file
//   setExistingImage(null); // remove existing review image
// };


//   const handleSubmit = async () => {
//     if (rating === 0) {
//       toast.error("Please select a rating");
//       return;
//     }

//     try {
//       setLoading(true);

//       const formData = new FormData();
//       formData.append("productId", productId);
//       formData.append("rating", rating);
//       formData.append("comment", feedback);

//       // only append image if user selected one
//       if (image) {
//         formData.append("image", image);
//       } else if (!existingImage) {
//         // user removed image
//         formData.append("removeImage", "true");
//       }

//       const res = await api({
//         method: SummaryApi.addOrUpdateReview.method,
//         url: SummaryApi.addOrUpdateReview.url,
//         data: formData,
//       });

//       if (res.data.success) {
//         toast.success("Review submitted successfully ");

//         // pass updated review back
//         onClose(res.data.review);
//         // onClose();
//       }

//     } finally {
//       setLoading(false);
//     }
//   };

// return createPortal(
//   <div
//     className="fixed inset-0 bg-black/40 flex items-center justify-center px-4 z-[9999]"
//     onClick={() => onClose()}
//   >
//     <div
//       className="bg-white w-full max-w-xl rounded-xl border-2 border-[#007BFF]
//                  flex flex-col max-h-[90vh]"
//         onClick={(e) => {
//           e.stopPropagation();
//         }}
//     >
//       {/* HEADER */}
//       <div className="px-6 py-4 border-b flex justify-between">
//         <h2 className="font-semibold text-lg">
//           {existingReview ? "Your Review" : "Add Review & Comments"}
//         </h2>
//         <button onClick={() => onClose()}>
//           <X />
//         </button>
//       </div>

//       {/* BODY */}
//         <div className="px-6 py-5 space-y-5 overflow-y-auto">

//           {/* RATING */}
//           <div>
//             <p className="text-sm font-medium mb-2">Rating</p>
//             <div className="flex gap-1">
//               {[1, 2, 3, 4, 5].map((i) => (
//                 <Star
//                   key={i}
//                   size={22}
//                   onClick={() => setRating(i)}
//                   onMouseEnter={() => setHover(i)}
//                   onMouseLeave={() => setHover(0)}
//                   className={`cursor-pointer ${
//                     i <= (hover || rating)
//                       ? "fill-[#FA8232] text-[#FA8232]"
//                       : "text-gray-300"
//                   }`}
//                 />
//               ))}
//             </div>
//           </div>

//           {/* IMAGE UPLOAD */}
//           <div>
//             <p className="text-sm font-medium mb-2">Image</p>

//             <label className="
//               w-16 h-16
//               border-2 border-dashed border-[#007BFF]
//               rounded-lg
//               flex items-center justify-center
//               cursor-pointer
//               hover:bg-blue-50
//             ">
//               <Upload size={18} className="text-[#007BFF]" />
//               <input
//                 type="file"
//                 className="hidden"
//                 onChange={handleImageChange}
//               />
//             </label>
//             {/* IMAGE PREVIEW */}
//             {(image || existingImage) && (
//               <div className="relative inline-block mt-2">
//                 <img
//                   src={
//                     image
//                       ? URL.createObjectURL(image)
//                       : existingImage
//                   }
//                   alt="preview"
//                   className="w-20 h-20 object-cover rounded border"
//                 />

//                 {/* REMOVE BUTTON */}
//                 <button
//                   type="button"
//                   onClick={handleRemoveImage}
//                   className="
//                     absolute -top-2 -right-2
//                     bg-white border rounded-full
//                     w-6 h-6 flex items-center justify-center
//                     shadow hover:bg-red-50
//                   "
//                   title="Remove image"
//                 >
//                   <X size={14} className="text-red-500" />
//                 </button>
//               </div>
//             )}
//           </div>

//           {/* FEEDBACK */}
//           <div>
//             <p className="text-sm font-medium mb-2">Feedback</p>
//             <textarea
//               value={feedback}
//               onChange={(e) => setFeedback(e.target.value)}
//               placeholder="Write down your feedback about our product & services"
//               className="
//                 w-full h-28
//                 border rounded-md
//                 px-3 py-2
//                 text-sm
//                 outline-none
//                 border-[#E4E7E9]
//                 focus:border-[#007BFF]
//               "
//             />
//           </div>

//           {/* ACTION */}
//           <button
//             onClick={handleSubmit}
//             disabled={loading || rating === 0}
//             className="
//               bg-[#007BFF]
//               text-white
//               px-6 py-2.5
//               rounded-lg
//               text-sm font-medium
//               disabled:opacity-50
//             "
//           >
//             {loading ? "Publishing..." : "PUBLISH REVIEW"}
//           </button>
//         </div>
//     </div>
//   </div>,
//   document.body
// );
// };

// export default ReviewModal;


import React, { useEffect, useState } from "react";
import { X, Star, Upload } from "lucide-react";
import { toast } from "react-hot-toast";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { createPortal } from "react-dom";

const ReviewModal = ({ 
  open, 
  onClose, 
  productId, 
  existingReview, 
  readOnly = false // true for admin panel, false for customer
}) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [existingImage, setExistingImage] = useState(null);
  const [review, setReview] = useState(null);

  // For customer mode - load existing review data
  useEffect(() => {
    if (!readOnly && existingReview && open) {
      setRating(existingReview.rating);
      setFeedback(existingReview.comment);
      setExistingImage(existingReview.images?.[0] || null);
      setImage(null);
    }

    if (!readOnly && !existingReview && open) {
      setRating(0);
      setFeedback("");
      setImage(null);
      setExistingImage(null);
    }
  }, [existingReview, open, readOnly]);

  // For admin mode - set review data
  useEffect(() => {
    if (readOnly && existingReview) {
      setReview(existingReview);
    }
  }, [readOnly, existingReview]);

  if (!open) return null;

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) setImage(file);
  };

  const handleRemoveImage = () => {
    setImage(null);
    setExistingImage(null);
  };

  const handleSubmit = async () => {
    if (rating === 0) {
      toast.error("Please select a rating");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("productId", productId);
      formData.append("rating", rating);
      formData.append("comment", feedback);

      if (image) {
        formData.append("image", image);
      } else if (!existingImage) {
        formData.append("removeImage", "true");
      }

      const res = await api({
        method: SummaryApi.addOrUpdateReview.method,
        url: SummaryApi.addOrUpdateReview.url,
        data: formData,
      });

      if (res.data.success) {
        toast.success("Review submitted successfully");
        onClose(res.data.review);
      }
    } finally {
      setLoading(false);
    }
  };

  // Admin Read-Only View
  if (readOnly) {
    return createPortal(
      <div
        className="fixed inset-0 bg-black/40 flex items-center justify-center px-4 z-[9999]"
        onClick={onClose}
      >
        <div
          className="bg-white w-full max-w-xl rounded-xl border-2 border-[#007BFF] 
                     flex flex-col max-h-[90vh]"
          onClick={(e) => e.stopPropagation()}
        >
          {/* HEADER */}
          <div className="px-4 sm:px-6 py-3 sm:py-4 border-b flex justify-between items-center">
            <h2 className="font-semibold text-base sm:text-lg">Review Details</h2>
            <button 
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X size={20} />
            </button>
          </div>

          {/* BODY */}
          <div className="px-4 sm:px-6 py-4 sm:py-5 space-y-5 overflow-y-auto">
            {review ? (
              <>
                {/* RATING */}
                <div>
                  <p className="text-sm font-medium mb-2 text-gray-600">Rating</p>
                  <div className="flex gap-1 items-center">
                    {[1, 2, 3, 4, 5].map((i) => (
                      <Star
                        key={i}
                        size={20}
                        className={
                          i <= review.rating
                            ? "fill-[#FA8232] text-[#FA8232]"
                            : "fill-gray-200 text-gray-200"
                        }
                      />
                    ))}
                    <span className="ml-2 text-sm text-gray-600">
                      ({review.rating}/5)
                    </span>
                  </div>
                </div>

                {/* USER INFO */}
                <div>
                  <p className="text-sm font-medium mb-2 text-gray-600">Reviewed by</p>
                  <p className="text-sm text-gray-800">
                    {review.userId?.name || "Anonymous"}
                  </p>
                  <p className="text-xs text-gray-500">
                    {review.userId?.email}
                  </p>
                </div>

                {/* REVIEW DATE */}
                <div>
                  <p className="text-sm font-medium mb-2 text-gray-600">Review Date</p>
                  <p className="text-sm text-gray-800">
                    {new Date(review.createdAt).toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </p>
                </div>

                {/* IMAGE */}
                {review.images && review.images.length > 0 && (
                  <div>
                    <p className="text-sm font-medium mb-2 text-gray-600">Review Image</p>
                    <div className="flex flex-wrap gap-2">
                      {review.images.map((img, index) => (
                        <img
                          key={index}
                          src={img}
                          alt={`Review ${index + 1}`}
                          className="w-20 h-20 sm:w-24 sm:h-24 object-cover rounded-lg border border-gray-200"
                        />
                      ))}
                    </div>
                  </div>
                )}

                {/* FEEDBACK */}
                <div>
                  <p className="text-sm font-medium mb-2 text-gray-600">Customer Feedback</p>
                  <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border border-gray-200">
                    <p className="text-sm text-gray-800 whitespace-pre-wrap">
                      {review.comment || "No feedback provided"}
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center py-8">
                <p className="text-gray-500">No review found</p>
              </div>
            )}

            {/* CLOSE BUTTON */}
            <div className="pt-2">
              <button
                onClick={onClose}
                className="w-full bg-[#007BFF] text-white px-6 py-2.5 rounded-lg 
                           text-sm font-medium hover:bg-[#0066dd] transition-colors"
              >
                CLOSE
              </button>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  }

  // Customer Editable View
  return createPortal(
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center px-4 z-[9999]"
      onClick={() => onClose()}
    >
      <div
        className="bg-white w-full max-w-xl rounded-xl border-2 border-[#007BFF]
                   flex flex-col max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="px-6 py-4 border-b flex justify-between">
          <h2 className="font-semibold text-lg">
            {existingReview ? "Your Review" : "Add Review & Comments"}
          </h2>
          <button onClick={() => onClose()}>
            <X />
          </button>
        </div>

        {/* BODY */}
        <div className="px-6 py-5 space-y-5 overflow-y-auto">
          {/* RATING */}
          <div>
            <p className="text-sm font-medium mb-2">Rating</p>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((i) => (
                <Star
                  key={i}
                  size={22}
                  onClick={() => setRating(i)}
                  onMouseEnter={() => setHover(i)}
                  onMouseLeave={() => setHover(0)}
                  className={`cursor-pointer ${
                    i <= (hover || rating)
                      ? "fill-[#FA8232] text-[#FA8232]"
                      : "text-gray-300"
                  }`}
                />
              ))}
            </div>
          </div>

          {/* IMAGE UPLOAD */}
          <div>
            <p className="text-sm font-medium mb-2">Image</p>
            <label className="
              w-16 h-16
              border-2 border-dashed border-[#007BFF]
              rounded-lg
              flex items-center justify-center
              cursor-pointer
              hover:bg-blue-50
            ">
              <Upload size={18} className="text-[#007BFF]" />
              <input
                type="file"
                className="hidden"
                onChange={handleImageChange}
                accept="image/*"
              />
            </label>
            
            {/* IMAGE PREVIEW */}
            {(image || existingImage) && (
              <div className="relative inline-block mt-2">
                <img
                  src={image ? URL.createObjectURL(image) : existingImage}
                  alt="preview"
                  className="w-20 h-20 object-cover rounded border"
                />
                <button
                  type="button"
                  onClick={handleRemoveImage}
                  className="
                    absolute -top-2 -right-2
                    bg-white border rounded-full
                    w-6 h-6 flex items-center justify-center
                    shadow hover:bg-red-50
                  "
                  title="Remove image"
                >
                  <X size={14} className="text-red-500" />
                </button>
              </div>
            )}
          </div>

          {/* FEEDBACK */}
          <div>
            <p className="text-sm font-medium mb-2">Feedback</p>
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Write down your feedback about our product & services"
              className="
                w-full h-28
                border rounded-md
                px-3 py-2
                text-sm
                outline-none
                border-[#E4E7E9]
                focus:border-[#007BFF]
              "
            />
          </div>

          {/* ACTION */}
          <button
            onClick={handleSubmit}
            disabled={loading || rating === 0}
            className="
              bg-[#007BFF]
              text-white
              px-6 py-2.5
              rounded-lg
              text-sm font-medium
              disabled:opacity-50
              hover:bg-[#0066dd]
              transition-colors
            "
          >
            {loading ? "Publishing..." : "PUBLISH REVIEW"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ReviewModal;
